import React from 'react';
import ImageTag from '../ImageTag/ImageTag';
import logo from '../Logo/logo.svg';

const BtLogo: React.FC = () => {
  return <ImageTag className="" src={logo} alt="Home" width="50" maxHeight="100" name={'Logo'} />;
};
export default BtLogo;
